import React from "react";
import { useCommandContext } from "utils/context/command";
import { COMMAND_TYPE_ICON_MAP } from "./constants";
import { getItemProps, getBreadcrumbs } from "./utils";

const Suggestion = ({ item, index }) => {
  const { values, commandsMap, actions } = useCommandContext();
  const addHistory = actions.addHistory;
  const reset = actions.reset;

  const itemProps = getItemProps({
    item,
    index,
    currentIndex: values.index,
    onClick: () => {
      addHistory(item.id);
    },
    afterClick: reset,
    actions
  });
  const breadcrumbs = getBreadcrumbs({ item, commandsMap });
  let iconNode;
  const Icon = item.type && COMMAND_TYPE_ICON_MAP[item.type];
  if (Icon) {
    iconNode = (
      <div className="fr">
        <Icon size={20} />
      </div>
    );
  }

  return (
    <div {...itemProps}>
      {breadcrumbs && (
        <span key={item.id} className="black-50 pr1">
          {breadcrumbs}
        </span>
      )}
      {item.name}
      {iconNode}
    </div>
  );
};

export default Suggestion;
